"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StepIndicator = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _range2 = _interopRequireDefault(require("lodash/range"));

require("./stepIndicator.scss");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var StepIndicator = function StepIndicator(props) {
  var currentStep = props.currentStep,
      totalSteps = props.totalSteps,
      captions = props.captions,
      doneIcon = props.doneIcon;
  var columnWidth = 100 / (totalSteps - 1);
  var marginAdjustment = "".concat(-36 / (totalSteps - 1), "px");
  return /*#__PURE__*/(0, _jsx2.default)("div", {
    className: "step-indicator-container"
  }, void 0, (0, _range2.default)(1, totalSteps + 1).map(function (step) {
    // Calculate step width and ensure the last step fits on the same row
    var containerStyle = {
      width: step !== totalSteps ? "".concat(columnWidth, "%") : 0,
      marginLeft: step !== 1 ? marginAdjustment : 0
    };
    var stepClass = 'next-step';

    if (step < currentStep) {
      stepClass = 'done-step';
    } else if (step === currentStep) {
      stepClass = 'current-step';
    }

    return /*#__PURE__*/(0, _jsx2.default)("div", {
      className: "step-container ".concat(stepClass),
      style: containerStyle
    }, step, /*#__PURE__*/(0, _jsx2.default)("div", {
      className: "step ".concat(stepClass)
    }, void 0, step < currentStep ? /*#__PURE__*/(0, _jsx2.default)("span", {
      className: "icon ".concat(doneIcon)
    }) : /*#__PURE__*/(0, _jsx2.default)("span", {}, void 0, /*#__PURE__*/(0, _jsx2.default)("strong", {}, void 0, step))), captions ? /*#__PURE__*/(0, _jsx2.default)("div", {
      className: "step-caption"
    }, void 0, /*#__PURE__*/(0, _jsx2.default)("span", {
      className: "step-caption-text"
    }, void 0, captions[step - 1])) : '');
  }));
};

exports.StepIndicator = StepIndicator;
StepIndicator.defaultProps = {
  doneIcon: 'icon-check'
};

var _default = (0, _compose.default)(_pure.default)(StepIndicator);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/wizard/StepIndicator.js
// module id = 2381
// module chunks = 25